var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"echarts-demo"},[_c('p',{staticClass:"chart-header"},[_c('span',{staticClass:"chart-info"},[_vm._t("default")],2)]),_c('div',{ref:"lineChart",staticStyle:{"width":"85vw","height":"400px"},attrs:{"id":"lineChart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }